<template>
  <div
    v-bind="$attrs"
    :style="[dimensionsStyles, colorData.colorStyles]"
    :class="[
      `repartition-bar-item__${orientation}`,
      colorData.colorClasses,
      { 'repartition-bar-item__disabled': disabled }
    ]"
    class="repartition-bar-item"
  >
    <slot />
  </div>
</template>

<script>
import { getBackgroundColorData } from './colorUtils'

export default {
  name: 'RepartitionBarItem',

  props: {
    orientation: {
      type: String,
      required: true
    },
    percentage: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    colorData () {
      return getBackgroundColorData(this.color)
    },

    dimensionsStyles () {
      switch (this.orientation) {
        case 'horizontal':
          return {
            width: `${this.percentage}%`,
            height: '100%'
          }
        case 'vertical':
          return {
            width: '100%',
            height: `${this.percentage}%`
          }
      }

      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.repartition-bar-item {
  &.repartition-bar-item__disabled {
    opacity: 0.25;
  }
}
</style>
